<app-page-heading [heading]="heading"
                  [hasBackButton]="true"
                  [backPageName]="backPageName"
                  [customRoute]="customRoute"
                  [tabName]="tabName">
</app-page-heading>

<div class="stepper-container">
    <mat-horizontal-stepper #stepper [linear]="true">

        <!---------------------------->
        <!-- General Step -->
        <!---------------------------->
        <mat-step #generalStep [completed]="generalFormGroup">
            <ng-template matStepLabel>General</ng-template>
            <form [formGroup]="generalFormGroup">
                <mat-grid-list cols="2" rowHeight="75px">
                    <mat-grid-tile>
                        <mat-form-field>
                            <mat-label>Name</mat-label>
                            <input matInput type="text" [formControl]="policyNameFormControl"
                                (blur)="blurPolicyholderOrPolicyholderGroupHeading()">
                        </mat-form-field>
                        <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Name')">help_outline</mat-icon>
                    </mat-grid-tile>


                    <mat-grid-tile>
                        <mat-form-field>
                            <mat-label>Entity Status</mat-label>
                            <mat-select [formControl]="entityStatusFormControl">
                                <mat-option *ngFor="let item of entityStatus" [value]="item.name">
                                    {{item.name}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Entity Status')">help_outline</mat-icon>
                    </mat-grid-tile>

                </mat-grid-list>
                <mat-grid-list cols="2" rowHeight="75px">
                    <mat-grid-tile>
                        <mat-form-field>
                            <mat-label>Policyholder Group Number</mat-label>
                            <input matInput type="text" [formControl]="policyholderGroupNumber">
                        </mat-form-field>
                        <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Policyholder Group Number')">help_outline</mat-icon>
                    </mat-grid-tile>
                    <mat-grid-tile>
                        <mat-form-field>
                            <mat-label>Start Date</mat-label>
                            <input matInput [matDatepicker]="startDatePicker" [formControl]="startDateFormControl" [max]="endDateFormControl.value">
                            <mat-datepicker-toggle matIconSuffix [for]="startDatePicker">
                            </mat-datepicker-toggle>
                            <mat-datepicker #startDatePicker></mat-datepicker>
                        </mat-form-field>
                        <mat-icon [matTooltip]="getInfoTooltip('Start Date')" class="info-icon">help_outline</mat-icon>
                    </mat-grid-tile>
                </mat-grid-list>
                <mat-grid-list cols="2" rowHeight="75px">
                    <mat-grid-tile>
                        <mat-form-field>
                            <mat-label>Business Type</mat-label>
                            <mat-select  [formControl]="businessTypeFormControl" (selectionChange)="onBusinessTypeSelectionChange($event.source.value)" [disabled]="isBusinessTypeDisabled">
                                <mat-option *ngFor="let type of businessTypes" [value]="type.value" >
                                    {{type.name}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Business Type')">help_outline</mat-icon>
                    </mat-grid-tile>
                    <mat-grid-tile>
                        <mat-form-field>
                            <mat-label>End Date</mat-label>
                            <input matInput [matDatepicker]="endDatePicker"
                                   [formControl]="endDateFormControl"
                                   [min]="startDateFormControl.value">
                            <mat-datepicker-toggle matIconSuffix [for]="endDatePicker"></mat-datepicker-toggle>
                            <mat-datepicker #endDatePicker></mat-datepicker>
                        </mat-form-field>
                        <mat-icon [matTooltip]="getInfoTooltip('End Date')" class="info-icon">help_outline</mat-icon>
                    </mat-grid-tile>
                </mat-grid-list>
                <mat-grid-list cols="2" rowHeight="75px">
                <mat-grid-tile >
                    <mat-form-field >
                        <mat-label>Central Group</mat-label>
                        <input matInput
                                placeholder="Enter Central Group"
                                [formControl]="centralGroupFormControl"
                                [matAutocomplete]="centralGroup"
                                (input)="onInputChangedSearchCentralGroups($event)"
                                (blur)="onCentralGroupBlur()"
                               [readonly]="isControlGroupDisabled" >
                        <mat-autocomplete
                        #centralGroup="matAutocomplete"
                        [panelWidth]="'30vw'"
                        (optionSelected)="onCentralGroupSelectionChange($event.option.value)">
                        <mat-option *ngFor="let option of filteredCentralGroups"
                                    [value]="option.policyholderGroupId">
                            {{ getCentralGroupDisplayStringFromPolicyholderGroupDTO(option) }}
                        </mat-option>

                        </mat-autocomplete>
                    </mat-form-field>
                    <mat-icon [matTooltip]="getInfoTooltip('Central Group')" class="info-icon">help_outline</mat-icon>
                    </mat-grid-tile>
                     <mat-grid-tile>
                        <mat-form-field data-testid="group-count-range">
                            <mat-label>Group Count Range</mat-label>
                            <mat-select [formControl]="groupCountRangeFormControl">
                                <mat-option *ngFor="let range of groupCountRanges" [value]="range.value">
                                    {{range.name}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <mat-icon [matTooltip]="getInfoTooltip('Group Count Range')" class="info-icon">help_outline
                        </mat-icon>
                    </mat-grid-tile>

                </mat-grid-list>
                <mat-grid-list cols="2" rowHeight="75px">
                    <mat-grid-tile>
                        <mat-form-field>
                            <mat-label>Broker</mat-label>
                            <mat-select [formControl]="brokerFormControl">
                                <mat-option *ngFor="let broker of brokers" [value]="broker.value">
                                    {{broker.name}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <mat-icon [matTooltip]="getInfoTooltip('Broker')" class="info-icon">help_outline
                        </mat-icon>
                    </mat-grid-tile>
                    <mat-grid-tile>
                        <mat-form-field>
                            <mat-label>Underwriting Category</mat-label>
                            <mat-select [formControl]="underwritingCategoryFormControl">
                                <mat-option *ngFor="let underwriting of underwritingCategories" [value]="underwriting.value">
                                    {{underwriting.name}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <mat-icon [matTooltip]="getInfoTooltip('Business Type')" class="info-icon">help_outline
                        </mat-icon>
                    </mat-grid-tile>
                    <mat-grid-tile></mat-grid-tile>
                    <!-- Show Add Concessions button only for Policyholder Groups -->
                    <mat-grid-tile>
                        <button mat-raised-button
                                color="primary"
                                (click)="onClickAddUnderwritingConcessions()"
                                [matTooltip]="getAddConcessionsTooltip()"
                                [disabled]="!allowedToEditConcessions">
                            <mat-icon>add</mat-icon>
                            Add New Concessions
                        </button>
                        <button mat-raised-button
                                color="primary"
                                style="margin-left: 8px"
                                (click)="onClickEditUnderwritingConcessions()"
                                [matTooltip]="getEditConcessionsTooltip()"
                                [disabled]="!underwritingConcessionsExist(underwritingConcessions) || !allowedToEditConcessions"
                                [matBadge]="getLatestConcessionPerType(underwritingConcessions).length"
                                matBadgeColor="accent"
                                matBadgePosition="above after">
                            <mat-icon>edit</mat-icon>
                            Edit Existing Concessions
                        </button>
                    </mat-grid-tile>
                </mat-grid-list>

                <!---------------------------->
                <!-- Divide/History -->
                <!---------------------------->
                <mat-divider style="margin-bottom: 16px;margin-top: 16px;"></mat-divider>
                <mat-grid-list style="margin-bottom: 50px" cols="2" rowHeight="200px">
                  <mat-grid-tile>
                  </mat-grid-tile>
                  <mat-grid-tile>
                    <div class="scroll-container">
                      <div class="left-content">
                        <label class="column-label claim-column-label">Concession History</label>
                      </div>
                      <div class="left-content" *ngIf="underwritingConcessions.length > 0">
                        <p class="reporting-list" *ngFor="let concession of underwritingConcessions">
                          <b>{{concession.underwritingType.name}}</b>: {{getDateDisplayString(concession.startDate)}} - {{getDateDisplayString(concession.endDate)}}
                          <mat-icon *ngIf="allowedToEditConcessions"
                                    class="mat-primary-color"
                                    matTooltip="DELETE"
                                    (click)="onClickDeleteUnderwritingConcession(concession)">
                            delete
                          </mat-icon>
                        </p>
                      </div>
                    </div>
                  </mat-grid-tile>
                </mat-grid-list>

                <div class="button-container">
                  <button mat-raised-button color="warn" disabled>Clear</button>
                  <button mat-raised-button matStepperNext color="primary">Next</button>
                </div>
            </form>
        </mat-step>

        <!---------------------------->
        <!-- Addresses Step -->
        <!---------------------------->
        <mat-step #addressStep [completed]="addressFormComponent?.selectedAddresses?.length>0">
            <ng-template matStepLabel>Addresses</ng-template>
            <greydom-address-form #addressFormComponent
                                  [data]="selectedPolicyHolderGroup"></greydom-address-form>
        </mat-step>

        <!---------------------------->
        <!-- Contacts Step -->
        <!---------------------------->

        <mat-step #contactsStep [completed]="contactFormComponent?.selectedContacts?.length>0">
            <ng-template matStepLabel>Contacts</ng-template>
            <greydom-contact-form #contactFormComponent
                                  [data]="selectedPolicyHolderGroup"></greydom-contact-form>

        </mat-step>

        <!---------------------------->
        <!-- Statutory Step -->
        <!---------------------------->

        <mat-step #statutoryStep [completed]="statutoryFormGroup">
            <ng-template matStepLabel>Statutory</ng-template>
            <form [formGroup]="statutoryFormGroup">
                <!-- Row-1 -->
                <mat-grid-list cols="2" rowHeight="75px">
                    <mat-grid-tile>
                        <mat-form-field>
                            <mat-label>Business License Number</mat-label>
                            <input [formControl]="businessLicenseNumberFormControl" matInput required type="text">
                        </mat-form-field>
                        <mat-icon [matTooltip]="getInfoTooltip('Business License Number')" class="info-icon">
                            help_outline
                        </mat-icon>
                    </mat-grid-tile>
                    <mat-grid-tile class="align-left">
                        <label>Vat Applicable </label>
                        <mat-radio-group [(ngModel)]="vatApplicable" [ngModelOptions]="{standalone: true}"
                                         aria-label="Select yes OR no" class="example-radio-group">
                            <mat-radio-button class="radio-button" style="margin-left: 20px;" value="Yes">
                                Yes &nbsp;
                            </mat-radio-button>
                            <mat-radio-button checked class="radio-button" value="No">
                                No
                            </mat-radio-button>
                        </mat-radio-group>
                        <mat-icon [matTooltip]="getInfoTooltip('VAT Applicable')" class="info-icon">help_outline
                        </mat-icon>
                    </mat-grid-tile>

                </mat-grid-list>
                <!-- Row-2 -->
                <mat-grid-list cols="2" rowHeight="75px">
                    <mat-grid-tile>
                        <mat-form-field>
                            <mat-label>Business Licence Expiry Date</mat-label>
                            <input [formControl]="businessLicenseExpiryFormControl"
                                   [matDatepicker]="businessLicenseExpiryDate"
                                   matInput>
                            <mat-datepicker-toggle [for]="businessLicenseExpiryDate" matIconSuffix>
                            </mat-datepicker-toggle>
                            <mat-datepicker #businessLicenseExpiryDate></mat-datepicker>
                        </mat-form-field>
                        <mat-icon [matTooltip]="getInfoTooltip('Business Licence Expiry Date')" class="info-icon">
                            help_outline
                        </mat-icon>
                    </mat-grid-tile>
                    <mat-grid-tile *ngIf="vatApplicable  === 'Yes'">
                        <mat-form-field>
                            <mat-label>Vat Number</mat-label>
                            <input [formControl]="vatNumberFormControl" matInput type="text">
                        </mat-form-field>
                        <mat-icon [matTooltip]="getInfoTooltip('VAT Number')" class="info-icon">help_outline</mat-icon>
                    </mat-grid-tile>
                </mat-grid-list>
                <!-- Row-3 -->
                <mat-grid-list cols="2" rowHeight="75px">
                    <mat-grid-tile>
                        <mat-label style="margin-right: 5px;">License Copy</mat-label>
                        <input (change)="handleInputChangeForLicenseCopy($event)" [disabled]="true"
                               accept="image/jpeg,application/pdf"
                               id="onLicenseFileUpload"
                               type="file"/>
                        <mat-icon [matTooltip]="getInfoTooltip('License Copy')" class="info-icon">help_outline
                        </mat-icon>
                    </mat-grid-tile>
                    <mat-grid-tile>

                        <mat-label>GST Applicable</mat-label>
                        <mat-radio-group [(ngModel)]="gstApplicable" [ngModelOptions]="{standalone: true}"
                                         aria-label="Select a yes OR no" class="example-radio-group"
                                         style="margin-left: 20px;">
                            <mat-radio-button class="radio-button " value="Yes">
                                Yes &nbsp;
                            </mat-radio-button>
                            <mat-radio-button checked class="radio-button" value="No">
                                No
                            </mat-radio-button>
                        </mat-radio-group>

                        <mat-icon [matTooltip]="getInfoTooltip('GST Applicable')" class="info-icon">help_outline
                        </mat-icon>
                    </mat-grid-tile>
                </mat-grid-list>
                <!-- Row-4 -->
                <mat-grid-list cols="2" rowHeight="75px">
                    <mat-grid-tile *ngIf="gstApplicable === 'Yes'">
                        <mat-form-field>
                            <mat-label>GST Number</mat-label>
                            <input [formControl]="gstNumber" matInput type="text">
                        </mat-form-field>
                        <mat-icon [matTooltip]="getInfoTooltip('GST Number')" class="info-icon">help_outline</mat-icon>
                    </mat-grid-tile>
                </mat-grid-list>

                <!-- Buttons -->
                <div class="button-container">
                    <button #statutoryBackButton color="primary" mat-raised-button matStepperPrevious>Back</button>
                    <button (click)="resetStatutoryFormGroup()" color="warn" mat-raised-button>Clear</button>
                    <button #finishButton
                            (click)="submitPolicyHolderGroup()"
                            [disabled]="isFinishButtonDisabled()" color="primary"
                            mat-raised-button>Finish
                        <mat-icon *ngIf="isFinishButtonDisabled()" [matTooltip]="getFinishButtonTooltip()"
                                  class="info-icon">help_outline
                        </mat-icon>
                    </button>
                </div>
            </form>
        </mat-step>


    </mat-horizontal-stepper>
</div>
